module.exports = __webpack_public_path__ + "img/Twitter_logo.9fd9b71b.png";